// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"fca29562","623":"d92adb4c"}[chunkId] + ".chunk.css";
};